import React, { useEffect, useMemo, useState } from "react";
import FeedbackBanner from "../../general/correct-feedback/FeedbackBanner";

const DROP_PATTERN = /\[drop\]/g;

const Dropdown2Question = ({
  question,
  dropdowns,
  questionKey,
  onDropdownsChange,
  showCheckButton,
  canCheck,
  onCheck,
  feedbackVisible,
  feedback,
  onCloseFeedback,
  showNextButton,
  onNext,
  showFinishButton,
  onFinish,
}) => {
  const safeDropdowns = useMemo(() => (Array.isArray(dropdowns) ? dropdowns : []), [dropdowns]);
  const parts = useMemo(() => String(question || "").split(DROP_PATTERN), [question]);
  const dropdownCount = Math.max(0, parts.length - 1);
  const [values, setValues] = useState({});

  useEffect(() => {
    setValues({});
    onDropdownsChange({}, false);
  }, [dropdownCount, onDropdownsChange, question, questionKey]);

  function updateValue(idx, value) {
    const nextValues = { ...values, [`drop${idx}`]: value };
    const allSelected = Array.from({ length: dropdownCount }, (_, i) => nextValues[`drop${i}`])
      .every((item) => String(item || "").trim().length > 0);

    setValues(nextValues);
    onDropdownsChange(nextValues, allSelected);
  }

  return (
    <>
      <div className="dropdown2-question">
        {parts.map((part, idx) => {
          const dropdown = safeDropdowns[idx] || {};
          const options = Array.isArray(dropdown.options) ? dropdown.options : [];

          return (
            <React.Fragment key={`${questionKey || "dropdown2"}-${idx}`}>
              {part.split("\n").map((line, lineIdx, lines) => (
                <React.Fragment key={`${questionKey || "dropdown2"}-${idx}-${lineIdx}`}>
                  {line}
                  {lineIdx < lines.length - 1 && <br />}
                </React.Fragment>
              ))}
              {idx < dropdownCount && (
                <select
                  className="dropdown2-select"
                  value={values[`drop${idx}`] || ""}
                  onChange={(e) => updateValue(idx, e.target.value)}
                  aria-label={`Випадаючий список ${idx + 1}`}
                >
                  <option value="">Оберіть...</option>
                  {options.map((option, optionIdx) => (
                    <option key={`${option}-${optionIdx}`} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              )}
            </React.Fragment>
          );
        })}
      </div>

      {showCheckButton && canCheck && (
        <button className="btn checkAnswer" onClick={onCheck} style={{ display: "inline-block" }}>
          Перевірити
        </button>
      )}

      {feedbackVisible && <FeedbackBanner feedback={feedback} closeFeedback={onCloseFeedback} />}

      {showNextButton && (
        <button className="btn nextAnswer" onClick={onNext} style={{ display: "inline-block" }}>
          Наступне завдання
        </button>
      )}

      {showFinishButton && (
        <button className="btn nextAnswer" onClick={onFinish} style={{ display: "inline-block" }}>
          Завершити
        </button>
      )}
    </>
  );
};

export default Dropdown2Question;
